module.exports = __webpack_public_path__ + "static/media/slide-3.82d51684.webp";